export const DEFAULT_INTRO_TITLE_KEY = 'title'

const AD_NAME_TITLE_KEYS: { pattern: string; key: string }[] = [
  { pattern: 'smalltalk', key: 'titleSmallTalk' },
  { pattern: 'businessmeeting', key: 'titleBusinessMeeting' },
  { pattern: 'charisma', key: 'titleCharisma' },
  { pattern: 'dating', key: 'titleDating' },
  { pattern: 'conflict', key: 'titleConflict' },
  { pattern: 'wellspokenperson', key: 'titleWellSpokenPerson' },
  { pattern: 'seducativeskill', key: 'titleSeducativeskill' },
]

export const getIntroTitleKeyByAdName = (adName: string): string => {
  const normalizedAdName = adName.toLowerCase()
  const match = AD_NAME_TITLE_KEYS.find(({ pattern }) =>
    normalizedAdName.includes(pattern),
  )

  return match ? match.key : DEFAULT_INTRO_TITLE_KEY
}
